/**
 * Fixed 7 GTKY questions shown in the popup.
 *
 * label     — displayed in the popup UI
 * surveyKey — matches q.question in the default GTKY survey (used for answer mapping)
 * options   — dropdown options; null means load from the survey question's options array
 */
export const GTKY_QUESTIONS = [
	{
		label: 'Buyer Type',
		surveyKey: 'Buyer Type',
		options: ['First Home Buyer', 'Second Home Buyer', 'Third Home Buyer', 'Investor', 'Downsizer']
	},
	{
		label: 'House and Land Budget',
		surveyKey: 'House and Land Budget',
		options: ['$500k-600k', '$600k-700k', '$700k-800k', '$800k-900k', '$900k-1m', '$1m-1.1m', '$1.1m-1.2m', '$1.2m-1.3m', '$1.3m-1.4m', '$1.4m-1.5m', '$1.5m +']
	},
	{
		label: 'House Type',
		surveyKey: 'Household Type',
		options: ['Single', 'Couple', 'Pre School Kids', 'Primary Kids', 'Secondary Kids', 'Empty Nester']
	},
	{
		label: 'Product Type',
		surveyKey: 'Product Type',
		options: ['Apartment', 'Townhome', 'Single Storey Home', 'Double Storey Home']
	},
	{
		label: 'Bedrooms',
		surveyKey: 'Bedrooms',
		options: ['2', '3', '4', '5+']
	},
	{
		label: 'Family Background',
		surveyKey: 'Family Background',
		options: ['Australian', 'European', 'Indian', 'Asian', 'UK', 'New Zealand']
	},
	{
		label: 'Land Size',
		surveyKey: 'Land Size (m2)',
		options: null // loaded dynamically — prepends 130m2 - 300m2 then survey options
	}
];

export const GTKY_EXTRA_LAND_SIZE_OPTION = '130m2 - 300m2';

export const getLandSizeOptions = (surveyLandSizeOptions = []) => [
	GTKY_EXTRA_LAND_SIZE_OPTION,
	...surveyLandSizeOptions
];
